import React from "react";

import {
  PRIMARIES,
  ACCESSORIES,
  OLYMPICS,
  STRONGMAN,
} from "../../../../utils/exercise-catalog";

const MobileCatalogSelectors = ({
  onSelectorClick,
  filter,
  selectedExercises,
}) => {
  const combinedItems = [
    ...ACCESSORIES.map((value) => {
      let count = 0;
      selectedExercises.assistant.forEach((ex) => {
        if (ex.primaryMuscleGroup === value) count++;
        if (value === "Other" && !ex.primaryMuscleGroup) count++;
      });
      return {
        type: "accessory",
        value,
        label: value,
        count,
      };
    }),
    ...PRIMARIES.map(({ value, label }) => ({
      type: "primary",
      value,
      label,
      count: selectedExercises[value].length,
    })),
    ...OLYMPICS.map(({ value, label }) => ({
      type: "olympic",
      value,
      label,
      count: selectedExercises[value].length,
    })),
    ...STRONGMAN.map(({ value, label }) => ({
      type: "strongman",
      value,
      label,
      count: selectedExercises[value].length,
    })),
  ];

  return (
    <ul className="mobile-catalog-selection">
      {combinedItems.map(({ type, value, label, count }) => (
        <li
          key={`${type}-${value}`}
          className={`category-item${filter === value ? " active" : ""}`}
        >
          <button
            data-button-type={filter === value ? "primary" : "text-white"}
            onClick={() => onSelectorClick(value)}
          >
            {label}
            {count ? <span>({count})</span> : null}
          </button>
        </li>
      ))}
    </ul>
  );
};

export default MobileCatalogSelectors;
